// eigenerNewsletter.ts — „Hat der Kontakt einen Newsletter?" (User 28.09.2026).
//
// Die Karte „Zuwendungen, Veranstaltungen & Newsletter" fragt seitdem in BEIDE
// Richtungen:
//   1. Hat der Kontakt einen EIGENEN Newsletter? Ja/Nein
//        wenn Ja: welcher (Freitext) | haben wir ihn abonniert? Ja/Nein
//   2. Abonniert der Kontakt UNSEREN Newsletter? (bestehend: `newsletter`,
//        `newsletterEmails`)
//
// Formularwerte sind "ja" | "nein" | "" — "" heißt „nicht beantwortet" und
// geht nicht mit. Spalten am Contact (Migration 202609280001):
// `eigenerNewsletter`, `eigenerNewsletterName`, `eigenenNewsletterAbonniert`.
//
// Eine Stelle für Hin- und Rückweg, damit Personen- und Firmen-Builder und die
// Rückabbildung (contactToFormState) nicht auseinanderlaufen.

type Felder = Record<string, unknown>;

const text = (v: unknown): string => (v == null ? "" : String(v).trim());

const alsBool = (v: unknown): boolean | undefined => {
  const t = text(v).toLowerCase();
  return t === "ja" ? true : t === "nein" ? false : undefined;
};

const alsJaNein = (v: unknown): string => (v === true ? "ja" : v === false ? "nein" : "");

/**
 * Payload-Teil für Anlage und Diff-Speichern. Name und „abonniert" gehen nur
 * bei „Ja" mit — bei „Nein" wären sie eine Aussage über einen Newsletter, den
 * es nicht gibt (der Diff leert sie dann mit `null`).
 */
export const eigenerNewsletterPayload = (formFields: Felder): Record<string, unknown> => {
  const hat = alsBool(formFields.eigenerNewsletter);
  if (hat === undefined) return {};
  if (!hat) return { eigenerNewsletter: false };
  const name = text(formFields.eigenerNewsletterName);
  const abonniert = alsBool(formFields.eigenenNewsletterAbonniert);
  return {
    eigenerNewsletter: true,
    ...(name ? { eigenerNewsletterName: name } : {}),
    ...(abonniert !== undefined ? { eigenenNewsletterAbonniert: abonniert } : {}),
  };
};

/** Rückweg Kontakt → Formularfelder. */
export const eigenerNewsletterFormState = (c: Felder): Record<string, string> => ({
  eigenerNewsletter: alsJaNein(c.eigenerNewsletter),
  eigenerNewsletterName: text(c.eigenerNewsletterName),
  eigenenNewsletterAbonniert: alsJaNein(c.eigenenNewsletterAbonniert),
});
